import "./ShortLandingPageContainer.css"
import Box from "@mui/material/Box";
import React, {forwardRef} from 'react';

const ShortLandingPageContainer = forwardRef(({children}, ref) => {
        return (
            <Box className={"short_landing_page_container"} ref={ref} sx={{
                padding: {xs: '40px 24px 40px', md: "40px 120px 40px"},
                width: "100%",
                boxSizing: "border-box",
                minHeight: {
                    xs: "var(--short_content_container_height_mobile)",
                    md: "var(--short_content_container_height)"
                },

            }}>{children}</Box>
        )
    })
;

export default ShortLandingPageContainer;